import { render } from "./Filters.vue?vue&type=template&id=8342855c"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"
script.render = render

export default script